import { Box, Typography, Button } from "@mui/material";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import '../modal/modal.css';
import { toast } from "react-toastify";
import InfoPopover from "../CommanComponents/InfoPopover";
import { callShopviewPostApi } from "../../function/ApiCallFunction";
import { DataContext } from "../../context/DataContext";

export default function UploadCouponOfferImage({  dataArr, onClose }) 
{  
    const {offer_id, offer_title } = dataArr;           
    
    const {loginData }  = useContext(DataContext);
    const store_id      = loginData?.store_info?.store_id; 

    const fileInputRef = useRef(null);

    const [imageFile,    setImageFile]      = useState("");
    const [imagePreview, setImagePreview]   = useState(null);
    const [loading,      setLoading]        = useState(false);

    /* ---------------- CLEANUP OBJECT URL ---------------- */
    useEffect(() => 
    {
        return () => 
        {
            if (imagePreview) { URL.revokeObjectURL(imagePreview); }
        };
    }, [imagePreview]);

     /* ---------------- RESET WHEN OFFER CHANGES ---------------- */
    const clearImageFields = useCallback(() => 
    {
        setImageFile(null);
        setImagePreview(null);
        if (fileInputRef.current) { fileInputRef.current.value = ""; }
    }, []);

    useEffect(() => { clearImageFields(); }, [offer_id,clearImageFields]);

    /* ---------------- FILE PICKER ---------------- */
    const handleImageChange = async (e) => 
    {
        const file = e.target.files?.[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) { toast.error("Only image files are allowed"); return; }
        if (file.size > 5 * 1024 * 1024)     { toast.error("Image must be under 5MB");      return; }

        const previewUrl = URL.createObjectURL(file);

        setImageFile(file);
        setImagePreview(previewUrl);
    }

    /* ---------------- COMPRESS TO BASE64 ---------------- */
    const compressAndConvertToBase64 = (file) => 
    {
        return new Promise((resolve, reject) => 
        {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = (event) => 
            {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => 
                {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    const maxSize = 800;
                    let { width, height } = img;

                    if (width > height && width > maxSize) {
                        height = (height * maxSize) / width;
                        width = maxSize;
                    } else if (height > maxSize) {
                        width = (width * maxSize) / height;
                        height = maxSize;
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    let quality = 0.8;
                    let base64Data = "";

                    while (quality > 0.3) 
                    {
                        const compressed = canvas.toDataURL("image/jpeg", quality);
                        base64Data = compressed.split(",")[1];

                        const sizeKB = Math.round((base64Data.length * 0.75) / 1024);

                        if (sizeKB <= 500) {
                            resolve(base64Data);
                            return;
                        }

                        quality -= 0.1;
                    }

                    reject(new Error("Unable to compress image under 500KB"));
                };

                img.onerror = reject;
            };

            reader.onerror = reject;
        });
    };

    /* ---------------- SAVE IMAGE ---------------- */
    const handleImageSave = async () => 
    {
        if (!imageFile) { toast.error("Please select the image");   return; }
        if (!store_id)  { toast.error("Store information missing"); return; }

        try 
        {
            setLoading(true);
            const base64Data = await compressAndConvertToBase64(imageFile);

            const payload = { mod: "UPDATE_CASHI_OFFER_IMAGE", data_arr: { store_id, offer_id, offerImage: { file_name: imageFile.name, file_data: base64Data,}, }, };
            const apiResult = await callShopviewPostApi("cashi-offer", payload);

            if (apiResult.status === "200" && apiResult.data) 
            {
                toast.success("Image updated successfully!"); 
                clearImageFields();
                onClose();

                setTimeout(() => {window.location.reload();}, 1500);

            } 
            else { toast.error(apiResult.data || "Update failed");  }
        } 
        catch (err) { toast.error("Something went wrong"); } 
        finally { setLoading(false); }

    };

    return (
        <div className="modal-overlay" >
        <div className="modal-container" style={{ maxWidth: '40%'}}>
                        
           <div className='headerStyles' ><h6>{offer_title} </h6> <span className='closeButtonStyles' onClick={onClose} >X</span></div>
           
           <div className="modal-content">
            <div className="row">

                <Typography sx={{ display: "flex", alignItems: "center", mb: 2 }}>Offer Artwork
                    <InfoPopover title="Offer Artwork" description="This image will be displayed on the Cashi App. 
                        For optimal resolution, use a 1x1 aspect ratio in PNG format"/>
                </Typography>

                <div className='col-3'>
                    <Button variant="outlined" component="label">
                        {imageFile ? imageFile.name : "Upload Image"}
                        <input type="file" accept="image/*" hidden ref={fileInputRef} onChange={handleImageChange} />
                    </Button>
                </div>

                {imagePreview && (
                    <Box sx={{ mt: 2 }}><img src={imagePreview} alt="Preview" style={{ width: "100%", maxHeight: "200px",objectFit: "contain",
                             border: "1px solid #ccc",borderRadius: "8px"}}/>
                    </Box>
                )}

          </div>
        </div>
   
           <div className="modal-actions" style={{justifyContent: 'flex-end' }}>
              <button onClick={onClose} disabled={loading} className="btn-group btn-confirm m-1">Close</button>  
              <button onClick={handleImageSave} disabled={loading} className="btn-group btn-confirm m-1">{loading ? "Updating..." : "Save"}</button>        
           </div>

       </div>
       </div>
    );
}
